module.exports = __webpack_public_path__ + "img/13_004.0eaed124.webp";